"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportsWithTurn = void 0;
const sportTypes_1 = require("./sportTypes");
exports.SportsWithTurn = [
    sportTypes_1.SportTypes.TENNIS,
    sportTypes_1.SportTypes.TABLE_TENNIS,
    sportTypes_1.SportTypes.VOLLEYBALL,
    sportTypes_1.SportTypes.BADMINTON,
    sportTypes_1.SportTypes.BEACH_VOLLEY,
];
//# sourceMappingURL=sportsWithTurn.js.map